<template>
  <div class="attachments module-cta">
    <div class="logos" v-for="logo in logos">
      <img :src="absoluteURL(logo.url)"/>
    </div>
    <div class="files" v-for="file in files">
      <a :href="absoluteURL(file.url)" target="_blank" class="button-white">Scarica pdf</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Attachments',
    props: ['attachments'],
    data() {
      return {
        values: [],
        files: [],
        logos: [],
      }
    },
    created() {
      this.attachments.forEach((attachment, key) => {
        switch (attachment.type) {
          case 'paragraph--file':
            this.files.push(attachment.file);
            break;
          case 'paragraph--logo':
            this.logos.push(attachment);
            break;
        }
      });
    },
    methods: {
      absoluteURL(relativeURL) {
        return process.env.VUE_APP_HOST_URL + relativeURL;
      }
    },
  }
</script>
